export default __webpack_public_path__ + "static/icon_menu_tag-1.0.0.png";